module.exports = __webpack_public_path__ + "i18n/pt-BR.89ad4c6d8a94867bbfc671b2e712bc28.json";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader/dist/cjs.js?name=i18n/[name].[hash].[ext]!./i18n/pt-BR.json
// module id = 1861
// module chunks = 0